import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

export const AuthImage = ({ fileId, alt, className, testid }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    if (fileId) {
      api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => {
        url = URL.createObjectURL(r.data);
        setSrc(url);
      }).catch(() => setSrc(null));
    }
    return () => url && URL.revokeObjectURL(url);
  }, [fileId]);
  if (!fileId || !src) return <div className={cn("flex items-center justify-center bg-muted text-muted-foreground", className)} data-testid={testid}><ImageOff className="h-6 w-6" /></div>;
  return <img src={src} alt={alt} className={cn("object-cover", className)} data-testid={testid} />;
};
